module.exports = __webpack_public_path__ + "static/img/5.cc08b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/5.png
// module id = ia7O
// module chunks = 1 3